import {
	type OrderPriceCreateDto,
	postOrdersIdPriceUpdate,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { invalidatePriceForOrder } from "Order/Api/invalidateOrderQueries";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const orderMutationsResource = Resources.base.order.mutations;

export const useCreateOrderPriceMutation = (orderId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: OrderPriceCreateDto) =>
			postOrdersIdPriceUpdate(data, orderId),
		),
		onError: (error) => {
			console.error(
				`${t(orderMutationsResource.orderPriceUpdateError)}:`,
				error,
			);
		},
		onSuccess: async () => {
			toast.success(t(orderMutationsResource.orderPriceUpdateSuccess));
			await invalidatePriceForOrder(queryClient, orderId);
		},
	});
};
